import styled from "styled-components";

export const Container = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: max-content;
  width: 424px;
  padding: 16px;
`;

export const ContainerChild = styled.div``;

export const ImageContainer = styled.div`
  display: flex;
  justify-content: center;
  gap: 8px;
`;

export const TextContainer = styled.div`
  margin-top: 4px;
`;

export const TextParagraph = styled.p`
  font-size: 12px;
  text-align: center;
  font-family: "sans-serif";
  line-height: 16px;
  font-weight: 500;
`;
